<span class="circle"
  [style.top]="getTop()"></span>
<div class="current_time"
     [style.top]="getTop()"></div>
